export const enDownloadsTranslations = {
  downloads: {
    panel: {
      title: 'Activity',
      title_in_progress: 'Preparing download',
      title_ready: 'Download ready',
      empty: 'Nothing here yet',
    },
    status: {
      in_progress: 'Preparing...',
      ready_for_download: 'Downloading...',
      downloaded: 'Downloaded',
      failed: 'Failed',
      downloading: 'Downloading',
      download_error: 'Download Error',
    },
    tooltip: {
      open: 'Activity',
    },
  },
};
